import {Alert, AlertTitle, Box, CircularProgress} from '@mui/material';
import {SnackbarContent, useSnackbar} from 'notistack';
import PropTypes from 'prop-types';
import React from 'react';

export const AlertSnackbar = React.forwardRef(
  ({closeButton = true, message, progress, title, severity, ...props}, ref) => {
    const {closeSnackbar} = useSnackbar();

    const onClose = () => closeSnackbar(props.id);

    return (
      <SnackbarContent ref={ref}>
        <Alert
          elevation={2}
          icon={false}
          onClose={!progress && closeButton ? onClose : undefined}
          severity={severity}
          sx={{width: '100%'}}
          variant="filled"
        >
          {title && <AlertTitle>{title}</AlertTitle>}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {progress && (
              <CircularProgress
                color="inherit"
                size={22}
                sx={{marginRight: 2}}
              />
            )}
            {message}
          </Box>
        </Alert>
      </SnackbarContent>
    );
  }
);

AlertSnackbar.propTypes = {
  message: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.string,
  progress: PropTypes.bool,
  closeButton: PropTypes.bool,
  severity: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AlertSnackbar;
